import React from 'react';
import { AllieIconProps } from '../../..';

export const ArrowLeftIcon: React.FC<AllieIconProps> = ({
  size = '12',
  color = 'var(--allie-color-neutral-50)',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M11.1667 5.75H0.75M0.75 5.75L5.75 0.75M0.75 5.75L5.75 10.75"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
